import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../contactus.scss";
//import axios from "axios";
import emailjs from 'emailjs-com';

const initialState = {
  name: "",
      email: "",
      interested: "",
      subject: "",
      detail: "",
      verified: 0,
};

class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state =initialState;
  }

  updateInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };


  sendEmail(form) {
  /*  axios({
      method: "POST",
      url: "https://doublethefun.com/xxoo10/api/send",
      data: this.state,
    })
      .then((response) => {
        if (response.data.status === "success") {
          alert("Message Sent.  Thank you!");
          this.props.history.push("Home");
        } else if (response.data.status === "fail") {
          alert("Message failed to send.  Please verify and try again.");
        }
      })
      .catch((error) => {
        alert("Message Sent.");
        this.props.history.push("Home");
      });
    */

    emailjs.sendForm(`service_y8hxiqs`, `template_k72rgzo`, form,`t98iTbKBPwxEkZvZt`)
      .then((result) => {
        alert("Message Sent, We will get back to you shortly", result.text);
        document.getElementById(form.id).reset();
      },
      (error) => {
        alert("An error occurred, Please try again", error.text);
      });
     }

  handleSubmit(event) {
    event.preventDefault();

    if (this.verified.value === "1") {
      this.sendEmail(event.target);
    } else {
      alert("Please click the Captcha to verify first.");
    }
  }

  render() {
    return (
      <div>
        <div className="col-md-12 text-center">
          <h1>Contact Us</h1>
        </div>
        <form
          id="contact-form"
          onSubmit={this.handleSubmit.bind(this)}
          method="POST"
        >
          <div>
            <fieldset>
              <div>
                <div>
                  <label>
                    Name:&nbsp;
                    <span title="This field is required.">*</span>
                  </label>
                  &nbsp;
                  <input
                    required={true}
                    type="text"
                    name="from_name"
                    id="from_name"
                    onChange={this.updateInput.bind(this)}
                    placeholder="John Doe"
                    size="60"
                    rows="1"
                    maxLength="128"
                  />
                </div>
                <div>
                  <label>
                    Email:&nbsp;
                    <span title="This field is required.">*</span>
                  </label>
                  &nbsp;&nbsp;
                  <input
                    required={true}
                    placeholder="john@address.com"
                    type="email"
                    name="email"
                    id="email"
                    onChange={this.updateInput.bind(this)}
                    size="60"
                  />
                </div>
              </div>
            </fieldset>
            <div>&nbsp;</div>
            <fieldset>
              <div>
                <div>
                  <label>I'm interested in:</label>
                  <div className="checkbox">
                    <div className="row">
                      <div className="column">
                        <input
                          type="checkbox"
                          name="interested"
                          onChange={this.updateInput.bind(this)}
                          value="1"
                        />
                        <label>Web Development</label>
                      </div>
                      <div className="column">
                        <input
                          type="checkbox"
                          name="interested"
                          onChange={this.updateInput.bind(this)}
                          value="4"
                        />
                        <label>IT Support Services</label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="column">
                        <input
                          type="checkbox"
                          name="interested"
                          onChange={this.updateInput.bind(this)}
                          value="2"
                        />
                        <label>Windows Development</label>
                      </div>
                      <div className="column">
                        <input
                          type="checkbox"
                          name="interested"
                          onChange={this.updateInput.bind(this)}
                          value="5"
                        />
                        <label>Suggestions</label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="column">
                        <input
                          type="checkbox"
                          name="interested"
                          onChange={this.updateInput.bind(this)}
                          value="3"
                        />
                        <label>Mobile App Development</label>
                      </div>
                      <div className="column">
                        <input
                          type="checkbox"
                          name="interested"
                          onChange={this.updateInput.bind(this)}
                          value="6"
                        />
                        <label>Training</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset>
              <div>
                <div>
                  <label>
                    Subject:&nbsp;
                    <span title="This field is required.">*</span>
                  </label>
                  &nbsp;
                  <input
                    required={true}
                    placeholder="What can we help you with?"
                    type="text"
                    name="subject"
                    onChange={this.updateInput.bind(this)}
                    size="59"
                    maxLength="128"
                  />
                </div>
                <div>
                  <label>
                    Give us some details on how we can help you:&nbsp;
                    <span title="This field is required.">*</span>
                  </label>
                  <div>
                    <textarea
                      required={true}
                      placeholder="Be as detailed as you like"
                      name="detail"
                      onChange={this.updateInput.bind(this)}
                      cols="64"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset>
              <div
                id="recaptcha"
                className="g-recaptcha"
                data-sitekey="6LdD5csZAAAAANEgDJgDmgvQiIyVJ5DpnV2-523B"
              ></div>
              <input
                type="hidden"
                id="verified"
                ref={(ref) => (this.verified = ref)}
              />
            </fieldset>
            <div>
              <input type="submit" name="op" value="Submit" />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(ContactUs);
